import modal from './modal';

export default (editor, opts = {}) => {
    const pfx = editor.getConfig().stylePrefix;
    const mdlClass = `${pfx}mdl-dialog-md`;

    modal(editor, mdlClass, 'Upgrade', opts.upgradeContent ||
        `<div style="display: flex; flex-direction: column; align-items: center; margin-bottom: 30px;">
            Upgrade To Premium Coming Soon
        </div>`);
};